<template>
  <v-card
    flat
    class="ma-3 pa-6"
  >
    <v-row align="center" class="pl-0 mb-6 pt-3 pr-3">
      <v-card-title>
        Variant Suppliers
      </v-card-title>
      <v-spacer></v-spacer>
      <v-autocomplete
        v-model="filter.supplier_id"
        :items="suppliers"
        item-value="id"
        item-text="name"
        clearable
        clear-icon="fas fa-times"
        class="mr-2"
        outlined
        multiple
        dense
        single-line
        hide-details
        label="Suppliers"
        @change="itemSearch()"
        @click:clear="itemSearch()"
      ></v-autocomplete>
      <v-autocomplete
        v-model="filter.in_stock"
        :items="stockFilters"
        item-value="id"
        item-text="name"
        clearable
        clear-icon="fas fa-times"
        class="mr-2"
        outlined
        dense
        single-line
        hide-details
        label="Stock"
        @change="itemSearch()"
        @click:clear="itemSearch()"
      ></v-autocomplete>
      <v-autocomplete
        v-model="filter.stock_synced_at"
        :items="stockSyncFilters"
        item-value="id"
        item-text="name"
        clearable
        clear-icon="fas fa-times"
        class="mr-2"
        outlined
        dense
        single-line
        hide-details
        label="Stock synced"
        @change="itemSearch()"
        @click:clear="itemSearch()"
      ></v-autocomplete>
      <v-text-field
        outlined
        dense
        v-model="filter.query"
        placeholder="Search..."
        append-icon="fas fa-search"
        clearable
        clear-icon="fas fa-times"
        single-line
        hide-details
        @keyup="itemSearch()"
        @click:clear="itemSearch()"
      ></v-text-field>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalCount"
      :footer-props="{ 'items-per-page-options': [5, 10, 50, 100, 250, 500] }"
      :loading="isSearching"
    >

      <template v-slot:item.purchase_price="{ item }">
        {{ formatCurrency(item.purchase_price) }}
      </template>
      <template v-slot:item.stock_synced_at="{ item }">
        {{ formatDateTime(item.stock_synced_at) }}
      </template>
    </v-data-table>

  </v-card>
  
</template>

<script>
import { inject } from 'vue'
import { formatCurrency, formatDateTime } from '@/utils'

export default {
  components: {
  },
  setup() {
    const api = inject('api')

    const threeDaysAgoTimestamp = Math.floor(Date.now() / 1000) - (60 * 60 * 24 * 3) // 3 days ago;


    const itemCollection = api.collection('product-variant-suppliers', {
      params: {
        expand: 'supplier',
      },
      filter: {
        supplier_id: 'in',
        query: 'query:sku',
        in_stock: {
            operator: function(field, value) { 
                switch(value) {
                    case '>0':
                      return ['gt', 0]
                    default:
                      return ['eq', value]
                }
            },
            field: 'in_stock',
        },
        stock_synced_at: {
            operator: function(field, value) { 
              switch(value) {
                case 'null':
                    return ['eq', null]
                case '>3days':
                    return ['lt', threeDaysAgoTimestamp]
                case '<3days':
                    return ['gt', threeDaysAgoTimestamp]
                default:
                    return ['neq', null]
              }
            },
            field: 'stock_synced_at',
        },
      },
      store: true,
    })

    const { items, filter, totalCount, options, isSearching } = itemCollection

    const headers = [
      { text: 'Supplier', value: 'supplier.name', },
      { text: 'SKU', value: 'sku' },
      { text: 'Purchase Price', value: 'purchase_price' },
      { text: 'Stock', value: 'in_stock' },
      { text: 'Stock synced', value: 'stock_synced_at' },
    ]

    const itemSearch = itemCollection.debounceSearch(300)

    const { items: suppliers } = api.collection('suppliers', { params: { sort: 'name' }}).all()

    const stockFilters = [
      { id: '0', name: 'Out of stock' },
      { id: '>0', name: 'In stock' },
    ]

    const stockSyncFilters = [
      { id: 'null', name: 'Not synced' },
      { id: '>3days', name: 'Synced (>3 days)' },
      { id: '<3days', name: 'Synced (last 3 days)' },
    ]

    return {
      user: api.user,
      headers,
      items,
      filter,
      itemSearch,
      totalCount,
      options,
      isSearching,
      formatCurrency,
      formatDateTime,
      suppliers,
      stockFilters,
      stockSyncFilters,
    }

  },
}
</script>


<style scoped>

:deep(.v-data-table table tbody tr:not(.v-data-table__empty-wrapper):hover) {
  cursor: pointer;
}

</style>
